import React from "react";
import { ErrorMessage, Field, FieldProps } from "formik";
import styled from "styled-components";

const FormFieldContainer = styled.div`
  .cms-form-label {
    //text-transform: uppercase;
    margin-right: 3%;
    margin-bottom: 0;
    width: 25%;
    text-align: right;
  }
  .verticalAlign {
    vertical-align: middle;
  }
  .cms-form-field {
    width: 70%;
    min-height: 27px;
    &.readOnly {
      color: gray;
    }
  }

  .cms-form-error {
    color: red;
    display: block;
    margin-left: 28%;
    font-size: 12px;
    height: 12px;
  }
  &.hidden {
    display: none;
  }
  &.extended {
    .cms-form-label {
      width: 10%;
    }

    .cms-form-field {
      width: 85%;
    }
  }
`;

interface IFormFieldProps {
  label: string;
  name: string;
  placeholder?: string;
  readOnly?: boolean;
  extended?: boolean;
  select?: boolean;
  options?: { value: string; label: string }[];
  hidden?: boolean;
}

export const FormField: React.FC<IFormFieldProps> = (props) => {
  const {
    label,
    name,
    placeholder = "",
    readOnly = false,
    extended = false,
    select = false,
    options,
    hidden = false,
  } = props;

  return (
    <FormFieldContainer
      className={`${extended ? "extended" : ""} ${hidden ? "hidden" : ""}`}
    >
      <label className="cms-form-label" htmlFor={name}>
        {label}
      </label>
      {select ? (
        <Field
          as="select"
          className={`cms-form-field ${readOnly ? "readOnly" : ""}`}
          id={name}
          name={name}
          disabled={readOnly}
        >
          {(options ?? []).map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Field>
      ) : (
        <Field
          className={`cms-form-field ${readOnly ? "readOnly" : ""}`}
          id={name}
          readOnly={readOnly}
          name={name}
          placeholder={placeholder}
        />
      )}
      <div className="cms-form-error">
        <ErrorMessage name={name} />
      </div>
    </FormFieldContainer>
  );
};

interface ICustomFormFieldProps extends IFormFieldProps {
  component: string | React.ComponentType<FieldProps>;
}

export const CustomFormField: React.FC<ICustomFormFieldProps> = (props) => {
  const { label, name, placeholder = "", readOnly = false, component } = props;

  return (
    <FormFieldContainer>
      <label className="cms-form-label" htmlFor={name}>
        {label}
      </label>
      <Field
        className={`cms-form-field verticalAlign ${readOnly ? "readOnly" : ""}`}
        id={name}
        readOnly={readOnly}
        name={name}
        placeholder={placeholder}
        component={component}
      />
      <div className="cms-form-error">
        <ErrorMessage name={name} />
      </div>
    </FormFieldContainer>
  );
};
